// src/assets/utils/statusColors.js
// Booking lifecycle (matches backend helpers/jobStatus.js)
export const BOOKING_STATUSES = ['Requested', 'Confirmed', 'In-Progress', 'Completed', 'Cancelled'];

export const statusColor = {
    Requested: 'warning',
    Confirmed: 'info',
    'In-Progress': 'primary',
    Completed: 'success',
    Cancelled: 'danger',
    // other statuses still shown elsewhere
    Pending: 'dark',
    Rejected: 'danger',
};
